let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fCeAS")).then(() => parcelRequire('ecK61'));